// Do we want to support async immediately?
// var promise = templateservice.renderAsync(name, data)
// This would support lazy loading rather than sticking templates in script tags
// On the other hand, templates are few and small - runeh
// Also, do we want to differentiate partials and templates really? It's a bit nonsensical,
// mostly implementation detail of mustache

import Mustache from 'mustache';

export default {
    name: 'templateservice',
    dependencies: ['sitesettings'],
    callable(sitesettings) {
        let templates;

        function _loadTemplates() {
            templates = Array.from(
                document.querySelectorAll('script[type="text/mustache"]')
            )
                .map(e => ({
                    [e.getAttribute('data-template')]: e.textContent,
                }))
                .reduce((acc, val) => Object.assign(acc, val), {});
        }

        // Note: we always pass in all partials, no need to tell the render function about them for
        // userland code.
        function render(name, data = {}) {
            const joinedData = { CTX: sitesettings, ...data };

            if (templates == null) {
                _loadTemplates();
            }

            if (templates.hasOwnProperty(name)) {
                return Mustache.render(templates[name], joinedData, templates);
            } else {
                console.log(`[Template service]: template not found: ${name}`);
            }
        }

        return {
            render,
        };
    },
};



// WEBPACK FOOTER //
// ./services/templateservice.js